import React from 'react';
import t from 'babel-plugin-yate/macro';

import {Text} from '../components/uiElem';
import Icon from '../components/Icons';

export function RefinancingPromo() {
  return (
    <>
      <Text ui="mars">
        {t`Aduna-ti toate creditele intr-unul singur, mai avantajos. Vei avea o singura rata fixa, mai mica si mai usor de gestionat, adaptata nevoilor si bugetului tau.`}
      </Text>

      <div className="mt-8">
        <Text ui="mars">
          <div className="inline-block border-b">{t`Avantajele tale`}</div>
        </Text>
      </div>

      <div className="flex mt-4">
        <div className="mr-2">
          <Icon name="CheckCircle" />
        </div>
        <div className="relative">{t`O singura rata fixa, mai usor de gestionat`}</div>
      </div>

      <div className="flex mt-4">
        <div className="mr-2">
          <Icon name="CheckCircle" />
        </div>
        <div className="relative">{t`Flexibilitate in alegerea perioadei de rambursare`}</div>
      </div>

      <div className="flex mt-4">
        <div className="mr-2">
          <Icon name="CheckCircle" />
        </div>
        <div className="relative">{t`Posibilitatea de a avea o rata adaptata bugetului tau`}</div>
      </div>

      <div className="flex mt-4">
        <div className="mr-2">
          <Icon name="CheckCircle" />
        </div>
        <div className="relative">{t`Posibilitatea de a obtine o suma suplimentara de bani`}</div>
      </div>

      <div className="mt-8">
        <Text ui="mars">
          <div className="inline-block border-b">{t`Cine poate beneficia?`}</div>
        </Text>
      </div>
      <div className="relative my-4">
        {t`Orice persoana cu unul sau mai multe credite active poate aplica online, pe baza documentelor standard.`}
      </div>
    </>
  );
}
